import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const HEARTPLACE_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Return to Work Letter (Timestamp & Review)",
    documentLabel: "{{ dateReceived }} Return to Work Letter",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN,
    group: "ushv-heartplace",
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Certificate of Medical Necessity (send to nurse)",
    documentLabel: "{{ dateReceived }} Certificate of Medical Necessity",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "ushv-heartplace",
  },
  [Classification.ADMIN_DEATH_CERTIFICATES]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Death/Expired report",
    documentLabel: "{{ dateReceived }} Death Report",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DEATH_CERTIFICATES,
    group: "ushv-heartplace",
  },
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Disability Paperwork (send to Nurse)",
    documentLabel: "{{ dateReceived }} Disability Form",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "ushv-heartplace",
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "FMLA Form",
    documentLabel: "{{ dateReceived }} FMLA Form",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "ushv-heartplace",
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "HP {location}, Referrals",
    displayName: "Patient Questionnaires",
    documentLabel: "{{ dateReceived }} Patient Questionnaire",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE,
    group: "ushv-heartplace",
  },
  [Classification.ADMIN_TRANSITION_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Transition of care (TDC)",
    documentLabel: "{{ dateReceived }} Transition of Care",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_TRANSITION_CARE,
    group: "ushv-heartplace",
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Mark High Priority"],
    assignedTo: "Provider,staff",
    displayName: "Cardiac Clearance Request",
    documentLabel: "{{ dateReceived }} Cardiac Clearance Request",
    folder: "Chart Documents > Cardiac Clearance",
    folderMapping: "Chart Documents > Cardiac Clearance",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "ushv-heartplace",
  },
  [Classification.CONSENT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Sayiner, Sibel",
    displayName: "Patient Forms, consents, etc.",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CONSENT,
    group: "ushv-heartplace",
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Stockings Rx",
    documentLabel: "{{dateReceived}} Stockings Rx",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "ushv-heartplace",
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Sayiner, Sibel",
    displayName: "ID/DL/Passport",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Leg Images",
    documentLabel: "{{ dateOfEvent }} Cardiac Leg Images",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_COLONOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Colonoscopy Report",
    documentLabel: "{{ dateOfEvent }} Colonoscopy",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_COLONOSCOPY,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "CT scans",
    documentLabel: "{{ dateOfEvent }} CT {{ bodyPart }}",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Echocardiogram Reports",
    documentLabel: "{{ dateOfEvent }} Echo {{ studyType }}",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "ECG/EKG",
    documentLabel: "{{ dateOfEvent }} ECG",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_ENDOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Endoscopy Report",
    documentLabel: "{{ dateOfEvent }} Endoscopy",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ENDOSCOPY,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Monitor Reports",
    documentLabel: "{{ dateOfEvent }} Monitor Report {{ studyType }}",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_MAMMOGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Mammogram Report",
    documentLabel: "{{ dateOfEvent }} Mammogram",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MAMMOGRAM,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "ACS No Transmission Notification",
    documentLabel: "{{ dateReceived }} Monitor Notification",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "CMR Report Radiology Report",
    documentLabel: "{{ dateOfEvent }} MRI {{ bodyPart }}",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Nuclear Scans",
    documentLabel: "{{ dateOfImagingResults }} {{ studyType }}",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_NM,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_PET]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Myocardial Perfusion (PET CT)",
    documentLabel: "{{ dateOfImagingResults }} Non-Cardiac PET",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_PET,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Exercise Treadmill Test Report",
    documentLabel: "{{ dateOfEvent }} Stress Test",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Ultrasound Report, Any Type (Abdominal, etc.)",
    documentLabel: "{{ dateOfEvent }} Ultrasound {{ bodyPart }}",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "ushv-heartplace",
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "X-Rays",
    documentLabel: "{{ dateOfEvent }} XRay {{ bodyPart }}",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "ushv-heartplace",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Sayiner, Sibel",
    displayName: "Insurance cards",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "ushv-heartplace",
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Sayiner, Sibel",
    displayName: "Patient Demographics",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "ushv-heartplace",
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "HP Labs MDAbx, Staff",
    displayName: "Lab results",
    documentLabel: "{{collectionDate}} {{ listOfNameOfLabs }}",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "ushv-heartplace",
  },
  [Classification.LAB_RESULTS_BP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "BP Logs (send to Doctor.)",
    documentLabel: "{{collectionDate}} BP Log",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_BP,
    group: "ushv-heartplace",
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Pathology reports (send to Dr.)",
    documentLabel: "{{collectionDate}} Path/Biopsy",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "ushv-heartplace",
  },
  [Classification.LAB_RESULTS_PT_INR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "PT/INR",
    documentLabel: "{{collectionDate}} PT-INR",
    folder: "Lab > INR",
    folderMapping: "Lab > INR",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PT_INR,
    group: "ushv-heartplace",
  },
  [Classification.LAB_RESULTS_QUANTAFLO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Quanta Flo (send to Dr.)",
    documentLabel: "{{collectionDate}} Quanta Flo",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_QUANTAFLO,
    group: "ushv-heartplace",
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Sayiner, Sibel",
    displayName: "Arbitration forms (Timestamp & Review)",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL,
    group: "ushv-heartplace",
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Non-USHV Clinic Notes",
    documentLabel: "{{ dateOfEvent }} Clinic Notes",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC,
    group: "ushv-heartplace",
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Hospital/Other Dr's Consult/Progress Notes",
    documentLabel: "{{ dateOfEvent }} Hospital Notes",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL,
    group: "ushv-heartplace",
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "HomeHealth Service/Physician Order",
    documentLabel: "{{ dateOfEvent }} HomeHealth Service/Order",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "ushv-heartplace",
  },
  [Classification.MEDICAL_HISTORY_MEDICATIONS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Sayiner, Sibel",
    displayName: "Medication List",
    documentLabel: "{{dateReceived}} Medications - Vaccines",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_MEDICATIONS,
    group: "ushv-heartplace",
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Medical records Release/Request",
    documentLabel: "{{ dateReceived }} Medical Records Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    priority: "{{schedulingPriority}}",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "ushv-heartplace",
  },
  [Classification.NOTIFICATION_HOSPITAL_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Hospital Discharge notes/Instructions",
    documentLabel: "{{ dateOfEvent }} {{ documentType }}",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_DISCHARGE,
    group: "ushv-heartplace",
  },
  [Classification.ORDER_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cupid Order Note",
    documentLabel: "{{ dateReceived }} Cardiac Order",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_CARDIAC,
    group: "ushv-heartplace",
  },
  [Classification.ORDER_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Unsupported CPT for Imaging Orders",
    documentLabel: "{{dateReceived}} CPT Needed",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_CLARIFICATION,
    group: "ushv-heartplace",
  },
  [Classification.ORDER_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Imaging Orders (send to Dr. & ask if ok to order)",
    documentLabel: "{{ dateReceived }} Imaging Orders",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_IMAGING,
    group: "ushv-heartplace",
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Sayiner, Sibel",
    displayName: "Lab orders",
    documentLabel: "{{dateReceived}} Lab Order",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_LAB,
    group: "ushv-heartplace",
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "All other documents that you don't think have a place in other folders.",
    documentLabel: "{{ dateReceived }} Patient Forms",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.OTHER,
    group: "ushv-heartplace",
  },
  [Classification.PHARMACY_RELATED_ALERT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Medication Alerts/Advisories/Therapeutic Alerts",
    documentLabel: "{{ dateReceived }} RX Therapeutic Alert",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_ALERT,
    group: "ushv-heartplace",
  },
  [Classification.PHARMACY_RELATED_CARE_CONSIDERATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Medication Considerations",
    documentLabel: "{{ dateReceived }} Care Consideration",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CARE_CONSIDERATION,
    group: "ushv-heartplace",
  },
  [Classification.PHARMACY_RELATED_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Prescriber Response Form",
    documentLabel: "{{ dateReceived }} RX Response Form",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CLARIFICATION,
    group: "ushv-heartplace",
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Refill Authorization Requests",
    documentLabel: "{{ dateReceived }} RX Refill Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "ushv-heartplace",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Prior Authorization Requests (for Prescriptions specifically)",
    documentLabel: "{{ dateReceived }} RX Prior Auth Request",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "ushv-heartplace",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Prior Authorization Approval/Denial (for Prescriptions specifically)",
    documentLabel: "{{ dateReceived }} RX Prior Auth {{authorizationStatus}}",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "ushv-heartplace",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Prior Authorization Requests",
    documentLabel: "{{ dateReceived }} Prior Auth Request",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "ushv-heartplace",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Insurance Authorizations, Exempt from Prior Auth., Denials etc.",
    documentLabel: "{{ dateReceived }} Prior Auth {{authorizationStatus}}",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "ushv-heartplace",
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cath Diagram",
    documentLabel: "{{ dateOfEvent }} Cardiac Report {{ procedure }}",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "ushv-heartplace",
  },
  [Classification.PROCEDURE_CARDIAC_VEIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Venous Questionnaires",
    documentLabel: "{{ dateReceived }} Venous Questionnaire",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC_VEIN,
    group: "ushv-heartplace",
  },
  [Classification.PROCEDURE_DEVICE_INFO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Implant Registration/Info/Card (Timestamp & Review)",
    documentLabel: "{{ dateReceived }} Device Info",
    folder: "Device Interrogations",
    folderMapping: "Device Interrogations",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_INFO,
    group: "ushv-heartplace",
  },
  [Classification.PROCEDURE_DEVICE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Device/Implantables Transfer Request",
    documentLabel: "{{ dateReceived }} Device Transfer Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_REQUEST,
    group: "ushv-heartplace",
  },
  [Classification.PROCEDURE_REHAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cardiac Rehab",
    documentLabel: "{{ dateOfEvent }} Cardiac Rehab",
    folder: "Chart Documents > Cardiac Rehab Notes",
    folderMapping: "Chart Documents > Cardiac Rehab Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_REHAB,
    group: "ushv-heartplace",
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Sleep Study Reports",
    documentLabel: "{{ dateOfEvent }} Sleep Report",
    folder: "Chart Documents > Sleep Studies",
    folderMapping: "Chart Documents > Sleep Studies",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_SLEEP,
    group: "ushv-heartplace",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Non-USHV Progress Notes",
    documentLabel: "{{ dateOfProgressNote }} Progress Notes",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "ushv-heartplace",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Inpatient Discharge Summary Report",
    documentLabel: "{{ dateOfEvent }} Hospital Discharge Summary",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "ushv-heartplace",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "H&P Notes",
    documentLabel: "{{ dateOfEvent }} HP Notes",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_RECORDS,
    group: "ushv-heartplace",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Summary of Care",
    documentLabel: "{{ dateOfEvent }} Hospital Summary of Care",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY,
    group: "ushv-heartplace",
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName:
      "Cardiac and Vascular Operative reports (cardiac catheterization, peripheral angiogram, venogram, IVC filter, left atrial appendage occlusion, TAVR, mitral clip, structural procedure for heart/vascular)",
    documentLabel: "{{ dateOfEvent }} {{ procedure }}",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "ushv-heartplace",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "HP {location}, Referrals",
    displayName: "Referral Order",
    documentLabel: "{{ dateOfReferral }} Referral Order",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    classification: Classification.REFERRAL,
    group: "ushv-heartplace",
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Referral Response",
    documentLabel: "{{ dateReceived }} Referral Response",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "ushv-heartplace",
  },
} as const;
